import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { isMobile } from 'react-device-detect';
import { LoadingPage } from "./components/Tabs/components";
import { TopRow, InfoRow, Content } from './components';
import { requestCurrentClub, requestCurrentClubMembers } from '../../../store/actionCreators/club';
import { isGameListLoading, getCurrentClubId } from "../../../store/selectors";
import { requestClubTables, resetClubTables } from '../../../store/actionCreators/table';
import { requestGames } from '../../../store/actionCreators/casinoGames';

const ClubMain = () => {
    const dispatch = useDispatch();
    const clubId = useParams().id;
    const gameListIsLoading = useSelector(isGameListLoading);
    const currentClubId = useSelector(getCurrentClubId);
    
    useEffect(() => {
        if( !!currentClubId ) {
            dispatch(requestGames(isMobile));
        }
    },  [currentClubId]);

    useEffect(() => {
        if (clubId) {
            // dispatch(resetClubTables());
            // dispatch(requestClubTables(clubId));

            dispatch(requestCurrentClub(clubId));
            dispatch(requestCurrentClubMembers());
        }
    }, [clubId]);
    return (
        <React.Fragment>
            {gameListIsLoading ?
                <LoadingPage type="clubLobby" /> :
                <div className={`clubMain`}>
                    <TopRow />
                    <InfoRow />
                    <Content />
                </div>
            }
        </React.Fragment>
    );
};

export default ClubMain;
